import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { HeaderContextProvider } from "../../core/contexts/HeaderContext";
import { IEstabelecimento } from "../../estabelecimento/interfaces/IEstabelecimento";
import { Layout } from "../../core/components/Layout";
import { ListarEntregadores } from "../pages/ListarEntregadores";
import { CadastrarEditarEntregador } from "../pages/CadastrarEditarEntregador";

interface IEntregadoresRoutesProps {
    autenticado: boolean;
}

export const EntregadoresRoutes = ({ autenticado }: IEntregadoresRoutesProps) => {
    return (
        <HeaderContextProvider>
            <Routes>
                <Route element={
                    <Layout titulo="Entregadores">
                        <PrivateRoutes
                            autenticado={autenticado}
                        />
                    </Layout>
                }>
                    <Route path="/" element={<ListarEntregadores />} />
                    <Route path="/cadastrar" element={<CadastrarEditarEntregador />} />
                    <Route path="/editar/:uuid" element={<CadastrarEditarEntregador />} />
                    <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
                </Route>
            </Routes>
        </HeaderContextProvider >
    );
}